// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./daura.jpg')
const allTwoEs = require('./creativity1.png')
const allTwoCa = require('./creativity1.png')
const allFourEs = require('./creativity2.gif')
const allFourCa = require('./creativity2.gif')
const catalogTwoEs = require('./creativity2.gif')
const catalogTwoCa = require('./creativity2.gif')
const catalogFourEs = require('./creativity2.gif')
const catalogFourCa = require('./creativity2.gif')

const model = creativityMediaModel({ catalogID: 'beer', allTwoEs, allTwoCa, allFourEs, allFourCa, catalogTwoEs, catalogTwoCa, catalogFourEs, catalogFourCa })

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) => model[params.catalogID][params.numberOfColumns][params.language]
}
